export enum USERS_QUERIES_ENUM {
  USERS_LIST = 'USERS_LIST',
  USER = 'USER',
}
